import { filter, map, tap } from 'rxjs/operators';
var AuthGuardOnlyAdmin = /** @class */ (function () {
    function AuthGuardOnlyAdmin(authService, settings, router) {
        var _this = this;
        this.authService = authService;
        this.settings = settings;
        this.router = router;
        this.authService.isAuthenticated$.subscribe(function (i) { return _this.isAuthenticated = i; });
    }
    AuthGuardOnlyAdmin.prototype.canActivate = function (route, state) {
        var _this = this;
        return this.authService.isDoneLoading$
            .pipe(filter(function (isDone) { return isDone; }))
            .pipe(tap(function (_) { return _this.isAuthenticated || _this.authService.login(state.url); }))
            .pipe(map(function (_) {
            if (_this.isAuthenticated && _this.settings.getUserClaims()["role"] === "Administrator") {
                return true;
            }
            _this.router.navigate(['/not-found']);
            return false;
        }));
    };
    return AuthGuardOnlyAdmin;
}());
export { AuthGuardOnlyAdmin };
